import { loginForm } from './loginForm';
import { notifications } from './notifications';
import { displayedLayers } from './displayedLayers';
import { mapFilters } from './mapFilters';
import { loggedUser } from './loggedUser';
import { map } from './map';

export const REDUCERS = {
    loginForm,
    notifications,
    displayedLayers,
    mapFilters,
    loggedUser,
    map,
};
